var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSaveTimeIcon = function SvgSaveTimeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 114,
    viewBox: "0 0 124 114",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9974 104.495C81.4386 104.495 104.495 81.4386 104.495 52.9974C104.495 24.5562 81.4386 1.5 52.9974 1.5C24.5562 1.5 1.5 24.5562 1.5 52.9974C1.5 81.4386 24.5562 104.495 52.9974 104.495Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9974 22.0989V52.9974L73.5963 63.2968",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9974 22.0989V52.9974L73.5963 63.2968M104.495 52.9974C104.495 81.4386 81.4386 104.495 52.9974 104.495C24.5562 104.495 1.5 81.4386 1.5 52.9974C1.5 24.5562 24.5562 1.5 52.9974 1.5C81.4386 1.5 104.495 24.5562 104.495 52.9974Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1379 75.7418L115.01 49.9922L98.1477 73.6818L114.005 83.8672L73.1328 109.502L90.7772 85.4694L74.1379 75.7418Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1379 75.7418L115.01 49.9922L98.1477 73.6818L114.005 83.8672L73.1328 109.502L90.7772 85.4694L74.1379 75.7418Z",
    fill: "#FEAC2D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaveTimeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saveTimeIcon.2d691f05.svg";
export { ForwardRef as ReactComponent };